import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getBodyParts } from '../api';

const BodyPartPage = () => {
  const [bodyParts, setBodyParts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const navigate = useNavigate();

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  useEffect(() => {
    getBodyParts()
      .then((res) => setBodyParts(res.data))
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading">読み込み中...</div>;

  return (
    <div className="page">
      <h1>部位を選択</h1>
      {!isOnline && (
        <div className="offline-banner">
          📵 オフラインモード｜記録画面ではオフライン保存が可能です
        </div>
      )}
      {bodyParts.length === 0 ? (
        <p className="empty-message">部位データを読み込めませんでした。一度オンラインで起動してください。</p>
      ) : (
        <div className="card-grid">
          {bodyParts
            .sort((a, b) => a.displayOrder - b.displayOrder)
            .map((part) => (
              <button
                key={part.name}
                className="card"
                onClick={() => navigate(`/exercises/${part.name}`)}
              >
                {part.name}
              </button>
            ))}
        </div>
      )}
    </div>
  );
};

export default BodyPartPage;